<template>
	<el-card :body-style="{ padding: '0px' }">
		<div slot="header" class="message header">
			<img src="../image/message_history.svg" class="header-icon">
			<span>
				<span class="head-title-col">Message History</span>
				<template v-if="getCurrentProvider">
					&nbsp;&nbsp;&middot;
					<span class="provider-name">
						{{ getProviderNameById(getCurrentProvider) }}
					</span>
					
				</template>
			</span>
		</div>
		<template v-if="showMultiProviders && patientProviderProfileList.length > 1">
			<div class="doctor-message">
			Select a doctor to view their messages
			</div>
			<ProviderSelect
					class="doctor-select"
					:profile-map="patient.profile_map"
					:initial-select="true"
					@providerSelect="setMessageProvider"></ProviderSelect>
		</template>
		<MessageList :messages="patientMessage"
			:patient-name="patient.given_name" :patient-id="patient.id"></MessageList>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import { mapState, mapActions, mapGetters } from 'vuex'
import MessageList from './List'
import ProviderSelect from './ProviderSelect'

export default {
	name: 'patient-sent-message-card',

	data() {
		return {
			messageProvider: null
		}
	},

	mounted() {
		if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1)
			this.messageProvider = this.patientProviderProfileList[0].provider
	},

	extends: OverviewCard,

	computed: {
		...mapGetters('provider', [
			'getPatientMessages',
			'getPatientTickets',
			'getCurrentProvider',
			'getProviderNameById'
		]),
		patientMessage() {
			const messages = this.getPatientMessages(this.patient.id) || []
			const tickets = this.getPatientTickets(this.patient.id) || []

			let patientMessageList = [ 
					...messages.flatMap((message) => {
						if(message.batch && Array.isArray(message.batch))
							return message.batch.map((batchMessage) => ({...batchMessage, mType: 'message', time: message.time, provider : message.provider}))
						else
							return [{...message, mType: 'message'}]
					}), 
					...tickets.map((ticket) => ({...ticket, mType: 'ticket'}))
				]
				.filter((message) => (message.status !== 'ready'))
				.sort((a, b) => (b.time - a.time))
			if(this.showMultiProviders && this.messageProvider)
				patientMessageList = patientMessageList.filter((message) => message.provider ? (message.provider.split(':')[0] === this.messageProvider) : false)
			else if(this.getCurrentProvider)
				patientMessageList = patientMessageList.filter((message) => message.provider ? message.provider.includes(this.getCurrentProvider) : false)
			return patientMessageList
		}
	},

	methods: {
		setMessageProvider(provider) {
			this.messageProvider = provider
		}
	},

	components: {
		MessageList,
		ProviderSelect
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.header-icon {
	height: 43px !important;
	margin-top: -1px !important;
}
</style>
